import { loadAjaxForm } from '../async/loadAjaxForm.js';
import { logError } from '../utils/logError';

const initNormal = function (subscribeForm) {
    const $ = window.jQuery;
    $(subscribeForm).ajaxForm({
        success: function (data) {
            hideLoader($('.na-subscribe'));
            showMessage(data.success['text']);
        },
        error: function (data) {
            hideLoader($('.na-subscribe'));
        }
    });
}

export const initSubscribeForm = function () {
    const subscribeForms = [...document.querySelectorAll('.na-subscribe form')];
    if (!subscribeForms.length) return;

    loadAjaxForm()
        .then(() => subscribeForms.forEach(initNormal))
        .catch(logError);
}